import "@chakra-ui/system";
import { getResponsiveTypography as r } from "../../../utils/typographyUtils.js";
const s = 1, i = 6, E = (o, n) => {
  const t = {};
  for (let e = s; e <= i; e++)
    t[`h${e}`] = {
      ...r(o[`heading${e}`]),
      pb: n
    };
  return t;
};
export {
  E as getStylesForAllHeading
};
